import {
  createTheme,
  CssBaseline,
  jssPreset,
  StylesProvider,
  ThemeProvider,
  // useMediaQuery,
} from '@material-ui/core'
import { create } from 'jss'
import rtl from 'jss-rtl'
import { PropsWithChildren } from 'react'

function createMuiTheme() {
  return createTheme({
    direction: 'rtl',
    // spacing: isXs ? (factor) => 4 * factor : (factor) => 8 * factor,
    typography: {
      fontFamily: 'vazir !important',
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 480,
        md: 720,
        lg: 960,
        xl: 1280,
      },
    },
  })
}

const jss = create({ plugins: [...jssPreset().plugins, rtl()] })

export function AppTheme(props: PropsWithChildren<object>) {
  // const isXs = useMediaQuery('@media (max-width:479.95px)')
  return (
    <StylesProvider jss={jss}>
      <ThemeProvider theme={createMuiTheme()}>
        <CssBaseline />
        {props.children}
      </ThemeProvider>
    </StylesProvider>
  )
}
